import React, { useMemo, useState } from 'react';
import { Card, Image, Tooltip } from 'antd';
import DefaultImage from './default-image.png';
import truncateText from '../../../../../../../utils/truncateText';
import InitialsAvatar from '../../../../../../CustomizedAntDesign/InitialsAvatar';
import formatToCurrency from '../../../../../../../utils/formatToCurrency';
import './styles.css';

const CollectionProductCard = props => {
  const { product, onClick } = props;
  const [isPdf] = useState(product.type === 'attachment' && product.fileType === 'application/pdf');

  const price = useMemo(() => {
    const value = product.vendorId ? product.msrp : product.price;

    return formatToCurrency(`${value}`);
  }, [product.price, product.vendorId, product.msrp]);

  return (
    <Card className="clients-v2-collection-product--card" onClick={onClick} hoverable>
      <div className="clients-v2-collection-product--card-header">
        <Image
          src={product.images?.[0]?.sourceUrl || product.url}
          width={220}
          height={220}
          preview={false}
          fallback={isPdf ? 'https://dashboard-v2-images.s3.us-east-1.amazonaws.com/pdf-fallback.svg' : DefaultImage}
        />

        {product.type !== 'attachment' && <div className="clients-v2-collection-product--card-header-price">{price}</div>}
      </div>

      <div className="clients-v2-collection-product--card-body">
        <span className="clients-v2-collection-product--card-body-title">
          <Tooltip title={product.name ?? product.description}>{truncateText(product.name ?? product.description, 24, { cutWords: true })}</Tooltip>
        </span>

        {product.type !== 'attachment' && <span className="clients-v2-collection-product--card-body-subtitle">{product.id}</span>}
      </div>

      <div className="clients-v2-collection-product--card-footer">
        <InitialsAvatar size={25} name={product.added_by_name} style={{ backgroundColor: '#F2A39B' }} />

        <span className="clients-v2-collection-product--card-footer-title">
          <Tooltip title={`Added by  ${product.added_by_name}`}>
            {truncateText(`Added by  ${product.added_by_name}`, 18, { cutWords: true })}
          </Tooltip>
        </span>
      </div>
    </Card>
  );
};

export default CollectionProductCard;
